/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'offCanvas',
        closeOnOutsideClick: true
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

	//VIDEO POPUP
    $('.js-popup-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
        closeMarkup : '<button title="%title%" type="button" class="mfp-close">Close</button>'
	});

    //ALERTS
    if ($('.alert-bar')) {
        var alertbar = $('.alert-bar');
        var closealertbar = $('.close-alertbar');

        $(closealertbar).on('click', function (e) {
            e.preventDefault();
            //close the alertbar
            alertbar.slideUp();
            // persist the dismissal in a cookie
            document.cookie = closealertbar.data('alert-cookie');
        });

    }

    if ($('.alert-popup').length > 0) {
        $.magnificPopup.open({
            items: {
                src: '#alert-popup',
                type: 'inline',
            },
            alignTop: true,
            modal: true,
            mainClass: 'mfp-fade'
        });
        $(document).on('click', '.close-alertpopup', function (e) {
            var closealertpopup = $(this);
            e.preventDefault();
            $.magnificPopup.close();

            // persist the dismissal in a cookie
            document.cookie = closealertpopup.data('alert-cookie');
        });
    }

})(jQuery)
